(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateMarsMorsController', EvaluationTemplateMarsMorsController);

    EvaluationTemplateMarsMorsController.$inject = ['GenericEntityDatatableService', 'CoreService',
        'ConfirmationService', 'EvaluationTemplateMarsMors', '$q', '$uibModal'];

    function EvaluationTemplateMarsMorsController(GenericEntityDatatableService, CoreService,
                                                  ConfirmationService, EvaluationTemplateMarsMors, $q, $uibModal) {

        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Care & Delivery Mars/Mors',
            newButtonTitle: 'New Care & Delivery Mars/Mors',
            entityClassHumanized: 'Care & Delivery Mars/Mors',
            entityStateName: 'evaluation-template-mars-mors',
            service: EvaluationTemplateMarsMors,
            serviceMethod: 'byFacility',
            params: params,
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: null,
                    title: 'Evaluation Template',
                    render: function (data) {
                        return data.evaluationTemplate ? data.evaluationTemplate.name : '-';
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Care & Delivery MARs/MORs',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/evaluation-template-mars-mors/update/evaluation-template-mars-mors-dialog.html',
                controller: 'EvaluationTemplateMarsMorsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            evaluationTemplate: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Care & Delivery MARs/MORs').result.then(function () {
                    EvaluationTemplateMarsMors.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
